import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=56ddde06&scoped=true&"
import script from "./Ellipsis.vue?vue&type=script&lang=ts&"
export * from "./Ellipsis.vue?vue&type=script&lang=ts&"
import style0 from "./Ellipsis.vue?vue&type=style&index=0&id=56ddde06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ddde06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ddde06')) {
      api.createRecord('56ddde06', component.options)
    } else {
      api.reload('56ddde06', component.options)
    }
    module.hot.accept("./Ellipsis.vue?vue&type=template&id=56ddde06&scoped=true&", function () {
      api.rerender('56ddde06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/search/components/Ellipsis.vue"
export default component.exports